import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module'
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { TrainingModule } from './training/training.module';

import { SecurityModule } from './security/security.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UtilsModule } from './utils/utils.module';
import { CommerceModule } from './commerce/commerce.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthTokenInterceptorService } from './auth-token-interceptor.service';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';


@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,

        SharedModule,
        CoreModule,
        TrainingModule,

        SecurityModule,
        NgbModule,
        UtilsModule,
        CommerceModule], providers: [
            { provide: LocationStrategy, useClass: HashLocationStrategy },
            { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptorService, multi: true },
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule { }
